import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";

interface Props {
  title: string
  onTitleChange: (newTitle: string) => void
}

const DetailsStep = (props: Props) => (
  <table className="s1_table bordergrid gray">
    <tbody>
      <tr>
        <td className="label">{RESX.GeneralLabels.Title}</td>
        <td>
          <OptionalTextInput value={props.title} onChange={props.onTitleChange} maxLength={serverReference.constants.freeFieldProfile.maxTitleLength} />
        </td>
      </tr>
    </tbody>
  </table >
);

export default DetailsStep;
